export const HOME = {
};

export const Q = {
  questionScreen: "question-screen",
  questionTitle: "question-title",
  questionProgressText: "question-progress-text",
  progressBar: "progress-bar",
  optionPrefix: "option-",
  otherInput: "other-input",
  searchInput: "tools-search-input",
  suggestionItemPrefix: "suggestion-",
  chipPrefix: "added-tool-chip-",
  backBtn: "question-back-btn",
  continueBtn: "question-continue-btn",
  additionalContextScreen: "additional-context-screen",
  additionalContextInput: "additional-context-input",
  additionalContextBackBtn: "additional-context-back-btn",
  additionalContextSkipBtn: "additional-context-skip-btn",
  additionalContextSubmitBtn: "additional-context-submit-btn",
  completionScreen: "completion-screen",
  restartBtn: "completion-restart-btn",
};

export const ADMIN = {
  page: "admin-page",
  passcodeInput: "admin-passcode-input",
  passcodeSubmit: "admin-passcode-submit",
  passcodeError: "admin-passcode-error",
  submissionsList: "admin-submissions-list",
  submissionRowPrefix: "admin-submission-row-",
  report: "admin-report",
  backToListBtn: "admin-back-to-list-btn",
  refreshBtn: "admin-refresh-btn",
};
